import { DownOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import i18next from 'i18next';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { labels, colors } from '../riskEvolution';

const Style = styled.div`
  display: flex;
  gap: 34px;

  .cont {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.cont-main {
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;

      .ant-btn {
        width: 120px;
      }
    }

    &.cont-flex { 
      flex-direction: row;
      gap: 10px
    }

    label {
      margin-bottom: 0px;
      font-size: var(--font-size-lg);
      font-weight: 600;
    }

    .round-score {
      padding: 10px;
      border-radius: 100%;
      
      label {
        color: white;
      }
    }
  }

  h1 {
    font-size: 20px;
    margin-bottom: 0px;
    font-weight: 600;
  }
`;

const getYear = (year) => moment(year).format('DD MMM YYYY');

export default function Header({
  data = {},
  nextYear = null,
  isCurrent = false,
  onToggle = () => { },
  opened = false,
}) {
  const roundScore = Math.round(data.score);
  const headerLabel = labels[roundScore];
  const headerColor = colors[roundScore];

  return (
    <Style>
      <div className="cont">
        <div className="cont cont-flex">
          <div className="cont">
            <div className="round-score" style={{ background: headerColor }}>
              <label>{(data.score || 0).toFixed(1)}</label>
            </div>
          </div>
          <div className="cont">
            <label>{i18next.t(headerLabel)}</label>
          </div>
        </div>
      </div>
      <div className="cont">
        <h1>
          {(typeof nextYear === 'object' && nextYear !== null) && `${getYear(nextYear.createdAt || nextYear.completedAt)} - `}
          {isCurrent ? i18next.t('Current') : getYear(data.createdAt || data.completedAt)}
        </h1>
      </div>
      <div className="cont cont-main">
        <Button
          icon={<DownOutlined />}
          type={!opened && 'primary'}
          onClick={onToggle}
          className='no-ln-height'
        >
          {opened ? i18next.t('Less') : i18next.t('More')}
        </Button>
      </div>
    </Style>
  );
}
